import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *, html, body, #root {
    font-family: 'Rubik', sans-serif;
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    outline: none;
    color: ${({ theme }) => theme.colors.textColorPrimary};
  }

  html, body, #root {
    width: 100vw;
    height: 100vh;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background: ${({ theme }) => theme.colors.gray400};
  }

  ::-webkit-scrollbar-thumb {
    /* Handle */
    background: ${({ theme }) => theme.colors.gray300};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    /* Handle on hover */
    background: ${({ theme }) => theme.colors.textColorSecondary};
  }
`;
